"use client";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { addZero, filterTime } from "@/lib/commonService";
import { useTranslation } from "@/src/i18n/client";
import { FmDrawer, FmIcon, FmImage } from "@/ui-component";
import { IStyleProps } from "@/src/app/interface";
import stl from "./styles/countDownPrice.module.scss";
import classnames from "classnames";
/**
 *接受3个参数,都是时间戳
 *1.now:现在时间
 *2.lastTime：截至日期
 *3.startTime:开始时间
 * @class CountDown
 * @extends {Component}
 */
interface IProps extends IStyleProps {
    startTime: number;
    lastTime: number;
    onClose?: Function;
    title?: any;
    opentit?: any;
    backgroundColor?: string;
    now: number;
}
const CountDownPrice: React.FC<IProps> = (props) => {
    const { onClose, startTime, lastTime } = props;
    const { t } = useTranslation("common");
    const [now, setNow] = useState(props.now ?? Math.floor(Date.now() / 1000));
    const [visible, setVisible] = useState(false);
    const [hm, setHm] = useState();

    const show = useMemo(
        () => now < lastTime && startTime < now,
        [lastTime, now, startTime],
    );
    const timerRef = useRef<any>(null);
    const timerHSRef = useRef<any>(null);
    const hmRef = useRef<any>(null);

    useEffect(() => {
        if (now > lastTime || startTime > now) {
            return;
        } else {
            timerRef.current = setInterval(() => {
                setNow((prev) => prev + 1);
                if (!show) {
                    clearInterval(timerRef.current);
                    clearInterval(timerHSRef.current);
                    onClose?.();
                }
            }, 1000);

            timerHSRef.current = setInterval(() => {
                if (hmRef.current < 9) {
                    hmRef.current++;
                } else {
                    hmRef.current = 0;
                }
                setHm(hmRef.current);
            }, 100);
        }
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
            if (timerHSRef.current) clearInterval(timerHSRef.current);
        };
    }, [lastTime, now, onClose, show, startTime]);

    const toggerVisible = () => {
        setVisible((prev) => !prev);
    };

    const { title, opentit, backgroundColor } = props;
    const date = useMemo(() => filterTime(lastTime - now), [lastTime, now]);

    return show ? (
        <div
            className={classnames(stl["count-down-container"], props.className)}
            style={{
                background:
                    backgroundColor ??
                    "url('https://df5apg8r0m634.cloudfront.net/images/770b988f37409e579f108fd93c651058.png') no-repeat center center",
                backgroundSize: "100%",
            }}
        >
            <div className={classnames(stl["flash-sale"])}>
                <FmImage
                    image="https://df5apg8r0m634.cloudfront.net/images/1215b4f6636925f1c544be32ba35431a.png"
                    className={stl["flash-sale-img"]}
                />
                <div
                    dangerouslySetInnerHTML={{
                        __html: title || t("Flash Sale"),
                    }}
                    className={stl["flash-sale-title"]}
                ></div>
                {opentit && (
                    <div
                        className={stl["icon-faq-content"]}
                        onClick={toggerVisible}
                    >
                        <FmIcon
                            icon="icon--FAQ"
                            style={{ color: "#fff", fontSize: "0.4rem" }}
                        />
                    </div>
                )}
            </div>
            <div className={classnames(stl["count-down-font"])}>
                <div>
                    <span className={classnames(stl["hs"])}>
                        {`${
                            date.day && parseInt(date.day.toString())
                                ? date.day
                                : "00"
                        }D `}
                    </span>
                    <span style={{ margin: "0 0.1rem" }}>:</span>
                    <span className={classnames(stl["hs"])}>{date.hour}</span>
                    <span style={{ margin: "0 0.1rem" }}>:</span>
                    <span className={classnames(stl["hs"])}>{date.min}</span>
                    <span style={{ margin: "0 0.1rem" }}>:</span>
                    <span className={classnames(stl["hs"])}>
                        {addZero(Math.round(Number(date.second)))}
                    </span>
                </div>
            </div>

            <FmDrawer
                // transparent
                open={visible}
                closeable={true}
                onClose={toggerVisible}
                headerChildren
                anchor="bottom"
                closeablePosition="right"
                // paperClassName={stl["dialog-paper"]}
                // contentClassName={stl["dialog-content"]}
            >
                {opentit && (
                    <div
                        className={classnames(stl["modal-container"])}
                        dangerouslySetInnerHTML={{
                            __html: opentit,
                        }}
                    ></div>
                )}
            </FmDrawer>
        </div>
    ) : null;
};

export default CountDownPrice;
